import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const visitorInfoService = {
  getList,
  checkOutById,
  create,
  update,
  confirmDivisionContact,
};

function getList(formId=null, params={}){
  return (
    axios
      .get(
        formId ? `${apiEndpoint.visitorInfo}?form_id=${formId}` : `${apiEndpoint.visitorInfo}`,
        {
          headers: authHeader(),
          params: params
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
      })
  );
}

function checkOutById(id){
  return (
    axios
      .post(
        `${apiEndpointFunction.visitorInfo(id)}/check-out-by-id`,
        {},
        {
          headers: authHeader()
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }        
      })
  );
}

function create(data){
  return (
    axios
      .post(
        `${apiEndpoint.visitorInfo}`,
        data,
        {
          headers: authHeader()
        }
      )
  ).then(res => {
    if(res && res.status === 200){
      return res.data;
    }
    return {};
  });
}

function update(data, id){
  return (
    axios
      .put(
        `${apiEndpointFunction.visitorInfo(id)}`,
        data,
        {
          headers: authHeader(),
        }
      )
  ).then(res => {
    if(res && res.status === 200){
      return res.data;
    }
    return {};
  });
}

// Staff confirm a contractor made contact with their division contact.
// Backend decides who may (contact user, main office users, owner/admin).
function confirmDivisionContact(id) {
  return axios
    .post(
      `${apiEndpoint.visitorInfo}/confirm-division-contact`,
      { id },
      {
        headers: authHeader()
      }
    ).then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
      return {};
    });
}
